// Polyfill localStorage for build/SSR environments
if (typeof localStorage === 'undefined') {
  (global as any).localStorage = {
    getItem: () => null,
    setItem: () => {},
    removeItem: () => {},
    clear: () => {},
    length: 0,
    key: () => null,
  };
}

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './i18n/config'; // Initialize i18n
import { logApiConfig } from './config/apiConfig';

if (typeof window !== 'undefined') {
  console.log('React app starting...', {
    location: window.location.href,
    userAgent: navigator.userAgent.substring(0, 50),
    rootElement: document.getElementById('root')
  });
  
  // Log API configuration after app starts
  logApiConfig();
}

const rootElement = typeof document !== 'undefined' ? document.getElementById('root') : null;
if (rootElement) {
  const root = ReactDOM.createRoot(rootElement as HTMLElement);

  console.log('Rendering React app...');

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  console.log('React app rendered!');
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
